import { ChatMessage, Room, USER_STATUS } from "./chat.message";

export interface AuthResponse {
  data: LoginResponseData
}

export interface LoginResponseData {
  userId: number;
  user: SystemUser;
  authToken: string;
  refreshToken: string;
}

export interface GetMessageResponse {
  data: MessagesFetcResponseData
}

export interface MessagesFetcResponseData {
  messages: ChatMessage[];
  pagination: PaginationMeta;
  statusCode: number;
  totalOldMessagesPagination: number;
}

export interface PaginationMeta {
  total_item: number;
  per_page: number;
  total_page: number;
  current_page: number;
  previous_page: number;
}


export interface SystemUser {
  id: string;
  userId: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  full_name: string;
  room: any;
  avatar: string | null;
  permissions: string[];
  createdAt: string;
  updatedAt: string;
  lastActiveAt: string;
  organizationId: string | null;
  status: 'ONLINE' | 'OFFLINE';
  deviceToken: string | null;
  deviceInfo: any;
  pinRooms: any;
  activeChats: any;
  authToken: string;
  businessId: string | null;
  isOwner: boolean;
  is_agent: boolean;
  account_status: 'active' | 'inactive' | string;
  availability: 'Available' | 'NotAvailable' | string;
}

export interface AgentListResponse {
  statusCode: number;
  success: boolean;
  results: ChatAgent[];
  hasMore: boolean;
  totalCount: number;
}

export interface UserChatHistoryMessagesResponse {
  limit: number;
  messages: ChatMessage[];
  statusCode: number;
  success: boolean;
  pagination: PaginationMeta
}


export interface ChatAgent {
  userId: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  username: string;
  avatar: string | null;
  status: AgentStatus;
  createdAt: string;
}

export interface ChatListResponse {
  statusCode: number;
  success: boolean;
  chats: Room[];
  totalPages: number;
  limit: number;
  page: number;
  total: number;
}

export interface AgentStatusStats {
  online: number;
  offline: number;
  busy: number;
  total_agents: number;
}

export interface AgentStatusResponse {
  statusCode: number;
  data: AgentStatusStats;
}

export interface statusSocketResponse {
  roomId: [],
  status: "Available" | "Offline" | "Busy",
  user: ChatAgent
  userId: number
}

export declare type TabsInterface = 'live' | 'unassigned' | 'mentions';
export declare type AgentStatus = "Available" | "Offline" | "Busy";

export interface ChatUserTyping {
  roomId: number;
  userId: number;
  username: string;
  status: USER_STATUS
}

//get room memebrs
export interface ChatRoomMembersResponse {
  statusCode: number;
  data: ChatRoomMembersData;
}

export interface ChatRoomMembersData {
  avatar: string;
  roomId: number;
  type: 'PRIVATE' | 'GROUP' | string;
  name: string;
  lm: string; // ISO date string
  isPublic: boolean;
  fname: string | null;
  ownerId: number;
  u: any;
  members: RoomMember[];
  groupAuther: any;
}

export interface RoomMember {
  id: string;
  roomId: number;
  userId: number;
  inviteId: string | null;
  permissions: string[];
  nickname: string | null;
  createdAt: string;
  updatedAt: string;
  unReadMessage: number;
  organizationId: string | null;
  isMention: boolean;
  isDeleted: boolean;
  lastActiveAt: string;
  user: RoomUser;
}

export interface RoomUser {
  id: string;
  avatar: string | null;
  full_name: string | null;
  username: string;
}


// User details

export interface UserDetails {
  statusCode: number;
  userId: number;
  avatar: string | null;
  email: string;
  full_name: string;
  info: UserInfo;
}

export interface UserInfo {
  MS_CID: {
    customer_id: number;
  };
  Customer: {
    name: string;
    email: string;
    address: string;
  };
  sales_reps: SalesRep[];
  Last_5_Orders: Order[];
  Latest_3_RMAs: RMA[];
  Latest_3_BrokenScreens: BrokenScreen[];
  Location: {
    shipping_address: string;
    ip_address: string;
  };
  Last_Active_Page: string;
  Last_Active_Url: string;
}

export interface SalesRep {
  rep_id: number;
  name: string;
}

export interface Order {
  order_id: string;
  status: string;
  created_at: string;
}

export interface RMA {
  rma_ref: string;
  rma_status: string;
  rma_status_label: string;
  total_placed_qty: number;
  accepted_qty: number;
  rejected_qty: number;
}

export interface BrokenScreen {
  request_id: string;
  status: string;
  status_label: string;
  total_qty: number;
  paid_amount: number | null;
}
